import { createSlice } from "@reduxjs/toolkit";
import { fetchRevenueByDeliveryStatus } from "./thunk";
import { RevenueByDeliveryStatusResponse } from "./thunk";

interface RevenueByDeliveryStatusState {
  data: RevenueByDeliveryStatusResponse | null;
  loading: boolean;
  error: string | null;
}

const initialState: RevenueByDeliveryStatusState = {
  data: null,
  loading: false,
  error: null,
};

const revenueByDeliveryStatusSlice = createSlice({
  name: "revenueByDeliveryStatus",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRevenueByDeliveryStatus.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRevenueByDeliveryStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchRevenueByDeliveryStatus.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch revenue by delivery status data";
        // Set default empty data on error
        state.data = {
          data: [],
          date_from: null,
          date_to: null,
          warehouse_ids: null,
        };
      });
  },
});

export default revenueByDeliveryStatusSlice.reducer;

